
// 验证数据结构
export const validateMetaStructure = (meta: any): boolean => {
    try {
      // 基本结构验证
      if (!meta || typeof meta !== "object") return false;
      if (!meta.setters || !meta.defaultValues) return false;
  
      // 验证setters结构
      if (!Array.isArray(meta.setters.props)) return false;
      if (!Array.isArray(meta.setters.layout)) return false;
  
      // 验证defaultValues结构
      if (meta.defaultValues?.props?.setters) return false;
  
      // 验证字段引用的完整性
      const allProps = new Set(meta.setters.props.map((p: any) => p.name));
      const validateFields = (fields: any[]) => {
        return fields.every((field) => {
          if (typeof field === "string") {
            const propName = field.replace("setters/props/", "");
            return allProps.has(propName);
          }
          return true;
        });
      };
  
      // 验证layout中的字段引用
      const isValid = meta.setters.layout.every((section: any) => {
        return section.items.every((item: any) => {
          if (!item.fields) return true;
          return validateFields(item.fields);
        });
      });
  
      return isValid;
    } catch (error) {
      console.error("Meta structure validation error:", error);
      return false;
    }
  };
  